module.exports = __webpack_public_path__ + "static/media/zenodo-home.e354765c.png";